
import { NotificationHandlerService } from '../notifications/notification-handler.service';

export const MULTICOLOR_FULL = 'multicolorfull';
export const BLUE_FULL = 'bluefull';
export const BLUE_FULL_LARGE = 'bluefull';
export const DOTS_FULL = 'dotsfull';

export class PreloaderHandler {

    public isLoaded = false;
    public preloaderText: string;
    public opacity: number;
    private resetItemCount: number;
    private itemLoadCount: number;
    private timeout = 0;
    private preloaderType: string;

    constructor(count: number, timeOut: number, preloaderType: string, opacity = 1.0) {
        this.resetItemCount = count;
        this.itemLoadCount = count;
        this.timeout = timeOut;
        this.preloaderType = preloaderType;
        this.preloaderText = '';
        this.opacity = opacity;
    }

    public updateText(text: string): void {
        this.preloaderText = text;
    }

    public itemLoaded(): void {
        this.itemLoadCount -= 1;
        if (this.itemLoadCount < 1) {
            setTimeout(() => this.isLoaded = true, this.timeout);
        }
    }

    public hasLoaded(): boolean {
        return this.isLoaded;
    }

    public hideLoading(): void {
        this.isLoaded = true;
    }

    public showLoading(): void {
        this.isLoaded = false;
        setTimeout(() => this.isLoaded = true, this.timeout);
    }

    public customReset(itemCount: number, preloaderText = '', opacity = 1.0): void {
        this.isLoaded = false;
        this.itemLoadCount = itemCount;
        this.preloaderText = preloaderText;
        this.opacity = opacity;
    }

    public reset(preloaderText = '', opacity = 1.0): void {
        this.isLoaded = false;
        this.itemLoadCount = this.resetItemCount;
        this.preloaderText = preloaderText;
        this.opacity = opacity;
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/preloader/preloader-handler.ts